import * as ActionTypes from "./category.type";

const initialState = {
  categoryData: [],
  totalCategories: null,
};

export const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CATEGORY:
      return {
        ...state,
        categoryData: action.payload.category || [],
        totalCategories: action.payload?.total || 0,
      };
    case ActionTypes.ADD_CATEGORY:
      return {
        ...state,
        categoryData: [...state.categoryData, action.payload],
        totalCategories: state.totalCategories + 1,
      };
    case ActionTypes.EDIT_CATEGORY:
      const updatedCategoryData = state.categoryData.map((item) => {
        if (item._id === action.payload.categoryId) {
          return {
            ...action.payload.data,
          };
        }
        return item;
      });
      return {
        ...state,
        categoryData: updatedCategoryData,
      };
    case ActionTypes.DELETE_CATEGORY:
      return {
        ...state,
        categoryData: state.categoryData.filter(
          (category) => category._id !== action.payload,
        ),
      };
    default:
      return state;
  }
};
